import { render, staticRenderFns } from "./mo-tab.html?vue&type=template&id=29188f15&external"
import script from "./mo-tab.ts?vue&type=script&lang=ts&external"
export * from "./mo-tab.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/agent/_work/9/s/Be.Vlaanderen.Mo.Vue/ClientApp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('29188f15')) {
      api.createRecord('29188f15', component.options)
    } else {
      api.reload('29188f15', component.options)
    }
    module.hot.accept("./mo-tab.html?vue&type=template&id=29188f15&external", function () {
      api.rerender('29188f15', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/shared/mo-tab/mo-tab.vue"
export default component.exports